<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <div class="v-search-btn">
        <el-date-picker value-format="yyyy-MM-dd" class="v-date" v-model="valuedate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
        <el-select v-model="recordtype" style="margin-left: 16px;" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
        <el-button type="primary" icon="el-icon-download" @click="clickExport" size="medium">导出</el-button>
      </div>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table v-loading="isLoading" :data="tableData" stripe highlight-current-row>
            <el-table-column align="center" width="250px" label="昵称/会员ID">
              <template slot-scope="scope">
                <div class="pay-member-photo">
                  <img :src="scope.row.member_wxheadurl" />
                </div>
                <div v-if="scope.row.member_name!==''" class="pay-member-name">{{ scope.row.member_name }}<br />ID：{{ scope.row.member_mid }}</div>
                <div v-else class="pay-member-name">{{ scope.row.member_wxname }}<br />ID：{{ scope.row.member_mid }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="电话号码">
              <template slot-scope="scope">
                <span>{{ scope.row.member_mobile }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="消费次数">
              <template slot-scope="scope">
                <span>{{ scope.row.spendtimes }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="累计消费">
              <template slot-scope="scope">
                <span>{{ scope.row.spendamount }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="累计充值">
              <template slot-scope="scope">
                <span>{{ scope.row.rechargeamount }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="充值次数">
              <template slot-scope="scope">
                <span>{{ scope.row.rechargetimes }} </span>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <el-pagination @current-change="currentChange" background v-if="total>20" layout="prev, pager, next" :current-page="page" :page-size="pageSize" :total="total">
      </el-pagination>
    </el-container>
  </el-container>
</template>
<script>
import { searchMemberList } from '@/views/webpc/MemberStatistics/rcStatisticsApp/apis'
export default {
  data () {
    return {
      isLoading: false,
      pageSize: 20,
      page: 1,
      total: 0,
      radio: '1',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      options: [{
        value: 0,
        label: '统计全部'
      }, {
        value: 1,
        label: '仅充值'
      }, {
        value: 2,
        label: '仅消费'
      }],
      valuedate: null,
      recordtype: 0,
      tableData: [],
      desc: '',
      params: {}
    }
  },
  methods: {
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    loadData () {
      this.isLoading = true
      let data = new FormData()
      data.append('page', this.page)
      data.append('size', this.pageSize)
      data.append('recordtype', this.recordtype)
      if (this.valuedate) {
        data.append('startdate', this.valuedate[0])
        data.append('enddate', this.valuedate[1])
      }
      searchMemberList(data)
        .then((result) => {
          this.isLoading = false
          if (result) {
            this.tableData = result.data.list
            this.total = result.data.pager.records
          }
        })
        .catch((error) => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    clickSearch () {
      this.page = 1
      this.loadData()
    },
    clickExport () {
      let fileLink = `api/Admin/Statistics/exportMemberOnRecords?recordtype=${this.recordtype}`
      if (this.valuedate) {
        fileLink = `api/Admin/Statistics/exportMemberOnRecords?startdate=${this.valuedate[0]}&enddate=${this.valuedate[1]}&recordtype=${this.recordtype}`
      }
      window.open(fileLink)
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/MemberStatistics/rcStatisticsApp/rcStatistics.vue